import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core';
import React, { useState } from 'react';
import { css } from '../styled';
import { ButtonWithPromise } from './ButtonWithPromise';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<any>;
  keyword?: string;
  unsafe?: boolean;
};

export const DeletionConfirmationDialogInner: React.FC<Omit<Props, 'open'>> = ({
  onClose,
  onConfirm,
  keyword = 'DELETE',
  unsafe
}) => {
  const [keywordInput, setKeywordInput] = useState('');
  const confirm = async () => {
    const result = await onConfirm();
    onClose();
    return result;
  };
  return (
    <>
      <DialogTitle
        classes={{
          root: css((t) => ({
            background: t.custom.colors.error.main,
            color: t.custom.colors.error.contrastText,
            marginTop: -t.spacing(2),
            marginLeft: -t.spacing(),
            marginRight: -t.spacing()
          }))
        }}
      >
        Are you sure?
      </DialogTitle>
      <DialogContent>
        {unsafe ? (
          <p>Please confirm this deletion.</p>
        ) : (
          <>
            <p>
              Confirm this deletion by typing: <strong>{keyword}</strong>
            </p>
            <TextField
              variant="outlined"
              fullWidth={true}
              value={keywordInput}
              onChange={(ev) => setKeywordInput(ev.target.value)}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <ButtonWithPromise
          variant="contained"
          color="secondary"
          disabled={!unsafe && keywordInput !== keyword}
          pending="Deleting..."
          onClick={confirm}
        >
          Delete
        </ButtonWithPromise>
      </DialogActions>
    </>
  );
};

export const DeletionConfirmationDialog: React.FC<Props> = ({
  open,
  ...props
}) => {
  return (
    <Dialog open={open} onClose={props.onClose} maxWidth="lg">
      <DeletionConfirmationDialogInner {...props} />
    </Dialog>
  );
};

export const withDeletionConfirmation = (
  onConfirm: () => Promise<any>,
  unsafe?: boolean,
  keyword?: string
) => ({ onClose }: { onClose: () => void }) => (
  <DeletionConfirmationDialogInner
    onConfirm={onConfirm}
    onClose={onClose}
    unsafe={unsafe}
    keyword={keyword}
  />
);
